import { PRESET_FEATURES } from "@follaw-fr/utils/features";
import { useAgendaStore } from "@follaw-fr/stores/agenda";
import { useJorfsStore } from "@follaw-fr/stores/jorfs";
import { usePetitionsStore } from "@follaw-fr/stores/petitions";
import { useNewsStore } from "@follaw-fr/stores/news";
import { useNominationsStore } from "@follaw-fr/stores/nominations";
import { useLegiWorkStore } from "@follaw-fr/stores/legi-work";
import { useAmendmentsStore } from "@/follaw-fr/stores/amendments";
import { useQuestionsStore } from "@follaw-fr/stores/questions";
import { useLegiReportStore } from "@follaw-fr/stores/legi-reports";
import { useInstituGroupsStore } from "@follaw-fr/stores/institutional-groups";
import { usePrmStore } from "@follaw-fr/stores/prm";
import { useLobbiesStore } from "@follaw-fr/stores/lobbies";
import { useSocialMediaStatsStore } from "@follaw-fr/stores/social-media/statistics";
import { useSocialMediaStore } from "@follaw-fr/stores/social-media/posts";
import { useStakeholdersStore } from "@follaw-fr/stores/social-media/stakeholders";
import { useTwitterArticlesStore } from "@follaw-fr/stores/social-media/articles";

export function useFeaturesStores() {
  const featuresStores = {
    [PRESET_FEATURES.AGENDA]: useAgendaStore(), // Agenda
    [PRESET_FEATURES.JORFS]: useJorfsStore(), // Journal Officiel
    [PRESET_FEATURES.PETITIONS]: usePetitionsStore(), // Pétitions
    [PRESET_FEATURES.NEWS_NEWS]: useNewsStore(), // Actualités - Communiqués
    [PRESET_FEATURES.NEWS_NOMINATIONS]: useNominationsStore(), // Actualités - Nominations
    [PRESET_FEATURES.LEGI_LEGIWORKS]: useLegiWorkStore(), // Travaux parlementaires - Dossiers législatifs
    [PRESET_FEATURES.LEGI_AMENDMENTS]: useAmendmentsStore(), // Travaux parlementaires - Amendements
    [PRESET_FEATURES.LEGI_QUESTIONS]: useQuestionsStore(), // Travaux parlementaires - Questions
    [PRESET_FEATURES.LEGI_REPORTS]: useLegiReportStore(), // Travaux parlementaires - Comptes-rendus et rapports
    [PRESET_FEATURES.LEGI_INSTITU_GROUPS]: useInstituGroupsStore(), // Travaux parlementaires - Commissions et autres organes
    [PRESET_FEATURES.PRM_NATIONAL]: usePrmStore(), // PRM - National & Régional, départemental & local
    [PRESET_FEATURES.PRM_REGIONAL]: usePrmStore(), // PRM - Régional, départemental & local
    [PRESET_FEATURES.PRM_LOBBIES]: useLobbiesStore(), // PRM - Lobbies
    [PRESET_FEATURES.SM_OVERVIEW]: useSocialMediaStatsStore(), // Social media - Overview
    [PRESET_FEATURES.SM_TWEETS]: useSocialMediaStore(), // Social media - Tweets
    [PRESET_FEATURES.SM_STAKEHOLDERS]: useStakeholdersStore(), // Social media - Parties prenantes
    [PRESET_FEATURES.SM_ARTICLES]: useTwitterArticlesStore(), // Social media - Articles
  };

  return {
    featuresStores,
  };
}
